export default __webpack_public_path__ + "static/media/howItWorksHire2.58b12613.png";